import { Alert as ReactAlert } from '@a-ui/react';
import { useFormikContext } from 'formik';
import React from 'react';
import { useIntl } from 'react-intl';
import uniqueArray from '../../util/uniqueArray';

interface FormErrorsProps {}

const FormErrors: React.FC<FormErrorsProps> = () => {
  const { errors } = useFormikContext();
  const { messages } = useIntl();

  if (!errors || !Object.keys(errors).length) {
    return <></>;
  }

  const formattedErrors = uniqueArray(Object.values(errors)).map(
    (message) => messages[message] || message,
  );

  return (
    <div className="u-margin-bottom">
      <ReactAlert inline theme="danger">
        <div dangerouslySetInnerHTML={{ __html: formattedErrors[0] }}></div>
      </ReactAlert>
    </div>
  );
};

export default FormErrors;
